// src/Pages/Usuario/Agenda/components/ResumenReserva.jsx
import React from "react";
import BotonDinamico from "./BotonDinamico";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../../../../firebase/config";

// función CLP local
const clp = (n) =>
  typeof n === "number" ? `$${n.toLocaleString("es-CL")}` : "—";

export default function ResumenReserva({
  parsed,
  planEntrada,
  precioOriginal,
  precioFinal,
  mitadFinal,
  cupon,
  setCupon,
  cuponInfo,
  cuponLoading,
  mensajeCupon,
  validarCupon,
  totalSesionesEstimadas,
  primarySlot,
  aceptaTerminos,
  setAceptaTerminos,
  isOk,
  usuario,
  reservarSesionIncluida,
  abrirPago,
}) 
{

    const [sesionSiguiente, setSesionSiguiente] = React.useState(null);

  React.useEffect(() => {
    if (!planEntrada?.planId) return;

    const qPlanReservas = query(
      collection(db, "reservas"),
      where("planId", "==", planEntrada.planId),
      where("estado", "in", ["pendiente", "aprobada", "realizada", "completada"])
    );

    const unsub = onSnapshot(qPlanReservas, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push(d.data()));

      const realizadas = arr.filter((r) =>
        ["realizada", "completada"].includes(r.estadoSesion)
      ).length;

      const activas = arr.filter((r) =>
        ["pendiente", "aprobada"].includes(r.estado)
      ).length;

      setSesionSiguiente(realizadas + activas + 1);
    });

    return () => unsub();
  }, [planEntrada]);


  return (
    <aside className="lg:sticky lg:top-6 h-max">
      <div className="bg-white/70 backdrop-blur-xl rounded-2xl shadow-[0_18px_30px_-18px_rgba(0,0,0,0.08)] border border-gray-200 p-5">
        
        <h3 className="font-semibold text-[#0E1A36] mb-3">Resumen</h3>

        {/* SERVICIO */}
        <div className="flex justify-between text-sm mb-2">
          <span className="text-gray-600">Servicio</span>
          <span className="font-medium text-[#0E1A36] text-right">
            {parsed?.categoria && parsed?.variante
              ? `${parsed.categoria}: ${parsed.variante}`
              : "—"}
          </span>
        </div>

        {/* SEGUIMIENTO SI ES PLAN */}
          {planEntrada && (
            <>
              {/* Seguimiento */}
              <div className="flex justify-between text-sm mb-1">
                <span className="text-gray-600">Seguimiento</span>
                <span className="font-semibold text-[#0E1A36]">
                  {sesionSiguiente
                    ? `Sesión ${sesionSiguiente} / ${planEntrada.sesiones_totales}`
                    : "Cargando..."}
                </span>
              </div>

              {/* Valor de la sesión */}
              {sesionSiguiente && (
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-gray-600">
                    {`Valor de la sesión ${sesionSiguiente} / ${planEntrada.sesiones_totales}`}
                  </span>
                  <span className="font-semibold text-[#0E1A36]">
                    {clp(planEntrada.precio_por_sesion)}
                  </span>
                </div>
              )}

              {/* Saldo restante */}
              <div className="flex justify-between text-sm mb-3">
                <span className="text-gray-600">Saldo restante</span>
                <span className="font-semibold text-[#0E1A36]">
                  {clp(planEntrada.monto_restante)}
                </span>
              </div>
            </>
          )}


        {/* SOLO mostrar precio si NO es plan */}
        {!planEntrada && (
          <div className="flex justify-between text-sm mb-2">
            <span className="text-gray-600">Precio</span>
            <span className="font-medium text-[#0E1A36]">
              {clp(precioFinal)}
            </span>
          </div>
        )}


        {/* PAGO RESUMEN (solo si no viene de plan) */}
        {!planEntrada && (
          <div className="flex justify-between text-sm mb-3">
            <span className="text-gray-600">
              {totalSesionesEstimadas > 1 ? "Reserva primera sesión" : "Reserva 50%"}
            </span>
            <span className="font-medium text-[#0E1A36]">
              {clp(mitadFinal)}
            </span>
          </div>
        )}


        {/* CUPÓN - SOLO SI NO ES PLAN */}
        {!planEntrada && (
          <div className="mt-3">
            <label className="block text-sm font-medium text-[#00698F]">
              ¿Tienes un cupón?
            </label>

            <div className="flex gap-2 mt-1">
              <input
                type="text"
                value={cupon}
                onChange={(e) => setCupon(e.target.value)}
                placeholder="Ej: EKINE10"
                className="flex-1 border border-gray-300 rounded-xl p-2 uppercase bg-white/90 focus:ring-2 focus:ring-[#3A6AFF]"
              />
              <button
                onClick={validarCupon}
                disabled={cuponLoading}
                className="px-3 py-2 rounded-xl bg-[#00698F] hover:bg-[#0089C4] text-white font-semibold disabled:opacity-50"
              >
                {cuponLoading ? "Validando..." : "Validar"}
              </button>
            </div>

            {mensajeCupon && (
              <p
                className={`mt-1 text-xs ${
                  cuponInfo?.ok ? "text-emerald-600" : "text-red-500"
                }`}
              >
                {mensajeCupon}
              </p>
            )}
          </div>
        )}

        {/* DESCUENTO */}
        {cuponInfo?.ok && cuponInfo?.descuento > 0 && (
          <>
            <div className="flex justify-between mt-2 text-sm text-emerald-700">
              <span>Descuento aplicado</span>
              <span>- ${cuponInfo.descuento.toLocaleString("es-CL")}</span>
            </div>

            <div className="flex justify-between font-semibold text-[#0E1A36]">
              <span>Total con descuento</span>
              <span>{clp(precioFinal)}</span>
            </div>
          </>
        )}

        {/* RESUMEN DE PAGO */}
        {/* SOLO mostrar bloque de pago si NO es un plan */}
        {!planEntrada && (
          <div className="flex justify-between text-sm mt-3">
            <span className="text-gray-600">
              {totalSesionesEstimadas > 1
                ? "Reserva primera sesión"
                : "Reserva 50%"}
            </span>
            <span className="font-medium text-[#0E1A36]">
              {clp(mitadFinal)}
            </span>
          </div>
        )}


        <hr className="my-2" />

        {/* FECHA */}
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Fecha</span>
          <span className="font-medium text-[#0E1A36]">
            {primarySlot?.fecha || "—"}
          </span>
        </div>

        {/* HORA */}
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Hora</span>
          <span className="font-medium text-[#0E1A36]">
            {primarySlot?.hora || "—"}
          </span>
        </div>

        {/* TÉRMINOS */}
        <div className="mt-4 flex items-start gap-2 text-xs text-gray-700">
          <input
            id="acepta-terminos"
            type="checkbox"
            className="mt-[3px]"
            checked={aceptaTerminos}
            onChange={(e) => setAceptaTerminos(e.target.checked)}
          />
          <label htmlFor="acepta-terminos">
            Declaro que he leído y acepto los{" "}
            <a
              href="/terminos"
              target="_blank"
              rel="noreferrer"
              className="text-blue-600 underline underline-offset-2"
            >
              Términos y Condiciones
            </a>
            .
          </label>
        </div>

        {/* BOTÓN DINÁMICO */}
        <div className="mt-4">
          <BotonDinamico
            isOk={isOk}
            aceptaTerminos={aceptaTerminos}
            planEntrada={planEntrada}
            reservarSesionIncluida={reservarSesionIncluida}
            abrirPago={abrirPago}
          />

          {!isOk && (
            <p className="mt-2 text-xs text-[#4B5563]">
              Completa los campos requeridos, selecciona un horario y asegúrate
              de tener tu cuenta creada e iniciada.
            </p>
          )}

          {!usuario && (
            <p className="mt-1 text-xs text-red-500">
              Debes crear tu cuenta e iniciar sesión antes de reservar.
            </p>
          )}
        </div>
      </div>
    </aside>
  );
}
